<template>
  <v-app id="app" light>
    <!-- <main> -->
      <router-view></router-view>
    <!-- </main> -->
  </v-app>
</template>

<script>
export default {
  name: 'app',
};
</script>

<style>
body {
  margin: 0;
  background: #fcfcfc;
  color: #222;
}

#app {
  font-family: 'PT Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 18px;
  line-height: normal;
  height: 100%;
}

h1, .h1, h2 {
  display: block;
  /*font-family: 'Open Sans', sans-serif;*/
  font-size: 34px;
  font-weight: 700;
  margin: 0 0 10px 0;
  color: #333;
}

h2 {
  font-size: 28px;
  color: #555;
}

main {
  height: 100%;
}

p {
  margin: 10px 0;
}

.brick {
  max-width: 920px;
  margin: 0 auto;
  padding: 0 20px;
}

.special-link-wrapper {
  position: relative;
}

.special-link {
  position: absolute;
  left: -50px;
  top: 5px;
  /*left: 10px;*/
}

.special-link .icon {
  color: rgba(0,0,0, .05);
}

.loader.centered {
  margin: 50px auto 0 auto;
}

.no-link {
  text-decoration: none;
}

.no-margin {
  margin: 0;
}

.fake-footer {
  height: 150px;
}

.nc-form .wrapper {
  margin: 30px 0;
}

.nc-form label {
  display: block;
  font-weight: bold;
}

.nc-form input {
  width: 100%;
  outline: none;
  border: solid 1px rgba(0,0,0, .1);
  background: #fff;
  padding: 4px;
}

.nc-form textarea {
  width: 100%;
  outline: none;
}

.nc-form .btn {
  margin: 0;
}

.url {
  border: dashed 1px #ddd;
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  background: #f9f9f9;
  font-size: 14px;
  word-break: break-all;
}

.back-nav-button {
  text-decoration: none;
}

#app .default-avatar {
  color: #bbb;
}

</style>



// WEBPACK FOOTER //
// src/App.vue